import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoVideo from 'eco-design/base/eco-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoButton from 'eco-design/base/eco-button';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function SectionA4() {
    const { t } = useLang('theProduct.SectionVideo');
    const { t: t1 } = useLang('theProduct.GooadsMore');
    const { locale } = getLocal();

    return (
        <div className={styles.SectionA4}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="btn-content">
                <EcoButton lRadius="ellipse" lHref={`https://${locale}.ecoflow.com/products/single-axis-solar-tracker`} lChildren={t1('learn_more')} />
            </div>
            <EcoSpaceSmall />
            <div className={`eco-content`}>
                <EcoVideo pc={'https://websiteoss.ecoflow.com/upload/video/1744617886099/video1.mp4'} autoPlay={true} loop={true} />
            </div>
            <EcoSpace />
        </div>
    );
}
